import Bar from "../Bar";
import classes from "../../styles/Bar.module.css";
import { getClasses } from "../../utils";
import { useAppSelector } from "../../hooks";
import CurrencyLabel from "../labels/CurrencyLabel";
import BalanceLabel from "../labels/BalanceLabel";
import FreeRoundsLabel from "../labels/FreeRoundsLabel";
import EngineInfo from "../labels/EngineInfo";
import { SOCIAL_CASINO_LANG, MaxWin } from "../../commander/Types";

const BottomBar: React.FC = () => {
  const { balance, currency, stake, freeRounds, language, maxWin } =
    useAppSelector((state) => {
      return {
        balance: state.details.balance,
        currency: state.details.currency,
        language: state.details.language,
        stake: state.selectors.stake.value,
        freeRounds: state.freeRounds,
        maxWin: state.details.maxWin,
      };
    });

  return (
    <Bar className={getClasses(classes, "opaque")}>
      <CurrencyLabel
        shape="rectangle"
        badge="Stake"
        value={stake}
        currency={currency}
      />
      <EngineInfo visible={maxWin === MaxWin.Germany} />
      <BalanceLabel
        insignia={language === SOCIAL_CASINO_LANG ? "text" : "icon"}
        shape="rectangle"
        direction="left"
        visible={!freeRounds.active}
        currency={currency}
        balance={balance}
      />
      <FreeRoundsLabel
        shape="rectangle"
        direction="left"
        visible={freeRounds.active}
        value={freeRounds.amount}
      />
    </Bar>
  );
};

export default BottomBar;
